import styled from 'styled-components';

export const ControlsContainer = styled.div``;

export const IconButton = styled.button`
  background: ${(props) => (props.active ? 'rgba(52, 152, 219, 0.9)' : 'rgba(52, 73, 94, 0.9)')};
  border: none;
  border-radius: 50%;
  width: 53px;  
  height: 53px; 
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: white;
  transition: background-color 0.2s;
  font-size: 1.2rem;  

  &:hover {
    background: ${(props) => (props.active ? 'rgba(41, 128, 185, 0.9)' : 'rgba(44, 62, 80, 0.9)')};
  }
`;
